// AUTO-GENERATED from backend/swiss_cities.py — validated fare cityIds.
export const SEO_LOCATIONS = [
  { slug: "kloten", cityId: "kloten", name: "Kloten" },
  { slug: "zurich", cityId: "zurich", name: "Zürich" },
  { slug: "zurich-hb", cityId: "zurich-hb", name: "Zürich HB" },
  { slug: "oerlikon", cityId: "oerlikon", name: "Zürich Oerlikon" },
  { slug: "winterthur", cityId: "winterthur", name: "Winterthur" },
  { slug: "uster", cityId: "uster", name: "Uster" },
  { slug: "dubendorf", cityId: "dubendorf", name: "Dübendorf" },
  { slug: "dietikon", cityId: "dietikon", name: "Dietikon" },
  { slug: "wetzikon", cityId: "wetzikon", name: "Wetzikon" },
  { slug: "horgen", cityId: "horgen", name: "Horgen" },
  { slug: "wadenswil", cityId: "wadenswil", name: "Wädenswil" },
  { slug: "meilen", cityId: "meilen", name: "Meilen" },
  { slug: "buelach", cityId: "buelach", name: "Bülach" },
  { slug: "regensdorf", cityId: "regensdorf", name: "Regensdorf" },
  { slug: "wallisellen", cityId: "wallisellen", name: "Wallisellen" },
  { slug: "opfikon", cityId: "opfikon", name: "Opfikon-Glattbrugg" },
  { slug: "thalwil", cityId: "thalwil", name: "Thalwil" },
  { slug: "affoltern", cityId: "affoltern", name: "Affoltern am Albis" },
  { slug: "rapperswil", cityId: "rapperswil", name: "Rapperswil-Jona" },
  { slug: "stgallen", cityId: "stgallen", name: "St. Gallen" },
  { slug: "wil", cityId: "wil", name: "Wil" },
  { slug: "gossau-sg", cityId: "gossau-sg", name: "Gossau SG" },
  { slug: "buchs-sg", cityId: "buchs-sg", name: "Buchs SG" },
  { slug: "bad-ragaz", cityId: "bad-ragaz", name: "Bad Ragaz" },
  { slug: "rorschach", cityId: "rorschach", name: "Rorschach" },
  { slug: "bern", cityId: "bern", name: "Bern" },
  { slug: "thun", cityId: "thun", name: "Thun" },
  { slug: "biel", cityId: "biel", name: "Biel/Bienne" },
  { slug: "interlaken", cityId: "interlaken", name: "Interlaken" },
  { slug: "grindelwald", cityId: "grindelwald", name: "Grindelwald" },
  { slug: "gstaad", cityId: "gstaad", name: "Gstaad" },
  { slug: "burgdorf", cityId: "burgdorf", name: "Burgdorf" },
  { slug: "langenthal", cityId: "langenthal", name: "Langenthal" },
  { slug: "spiez", cityId: "spiez", name: "Spiez" },
  { slug: "basel", cityId: "basel", name: "Basel" },
  { slug: "liestal", cityId: "liestal", name: "Liestal" },
  { slug: "allschwil", cityId: "allschwil", name: "Allschwil" },
  { slug: "pratteln", cityId: "pratteln", name: "Pratteln" },
  { slug: "lausanne", cityId: "lausanne", name: "Lausanne" },
  { slug: "montreux", cityId: "montreux", name: "Montreux" },
  { slug: "vevey", cityId: "vevey", name: "Vevey" },
  { slug: "nyon", cityId: "nyon", name: "Nyon" },
  { slug: "yverdon", cityId: "yverdon", name: "Yverdon-les-Bains" },
  { slug: "morges", cityId: "morges", name: "Morges" },
  { slug: "geneva", cityId: "geneva", name: "Genève" },
  { slug: "carouge", cityId: "carouge", name: "Carouge" },
  { slug: "lucerne", cityId: "lucerne", name: "Luzern" },
  { slug: "emmen", cityId: "emmen", name: "Emmen" },
  { slug: "kriens", cityId: "kriens", name: "Kriens" },
  { slug: "sursee", cityId: "sursee", name: "Sursee" },
  { slug: "weggis", cityId: "weggis", name: "Weggis" },
  { slug: "zug", cityId: "zug", name: "Zug" },
  { slug: "baar", cityId: "baar", name: "Baar" },
  { slug: "cham", cityId: "cham", name: "Cham" },
  { slug: "aarau", cityId: "aarau", name: "Aarau" },
  { slug: "baden", cityId: "baden", name: "Baden" },
  { slug: "wettingen", cityId: "wettingen", name: "Wettingen" },
  { slug: "wohlen-ag", cityId: "wohlen-ag", name: "Wohlen AG" },
  { slug: "brugg", cityId: "brugg", name: "Brugg" },
  { slug: "zofingen", cityId: "zofingen", name: "Zofingen" },
  { slug: "rheinfelden", cityId: "rheinfelden", name: "Rheinfelden" },
  { slug: "frauenfeld", cityId: "frauenfeld", name: "Frauenfeld" },
  { slug: "kreuzlingen", cityId: "kreuzlingen", name: "Kreuzlingen" },
  { slug: "arbon", cityId: "arbon", name: "Arbon" },
  { slug: "amriswil", cityId: "amriswil", name: "Amriswil" },
  { slug: "schaffhausen", cityId: "schaffhausen", name: "Schaffhausen" },
  { slug: "neuhausen", cityId: "neuhausen", name: "Neuhausen am Rheinfall" },
  { slug: "chur", cityId: "chur", name: "Chur" },
  { slug: "davos", cityId: "davos", name: "Davos" },
  { slug: "stmoritz", cityId: "stmoritz", name: "St. Moritz" },
  { slug: "arosa", cityId: "arosa", name: "Arosa" },
  { slug: "flims", cityId: "flims", name: "Flims" },
  { slug: "lenzerheide", cityId: "lenzerheide", name: "Lenzerheide" },
  { slug: "klosters", cityId: "klosters", name: "Klosters" },
  { slug: "lugano", cityId: "lugano", name: "Lugano" },
  { slug: "bellinzona", cityId: "bellinzona", name: "Bellinzona" },
  { slug: "locarno", cityId: "locarno", name: "Locarno" },
  { slug: "ascona", cityId: "ascona", name: "Ascona" },
  { slug: "mendrisio", cityId: "mendrisio", name: "Mendrisio" },
  { slug: "sion", cityId: "sion", name: "Sion" },
  { slug: "zermatt", cityId: "zermatt", name: "Zermatt" },
  { slug: "verbier", cityId: "verbier", name: "Verbier" },
  { slug: "brig", cityId: "brig", name: "Brig" },
  { slug: "crans-montana", cityId: "crans-montana", name: "Crans-Montana" },
  { slug: "saas-fee", cityId: "saas-fee", name: "Saas-Fee" },
  { slug: "martigny", cityId: "martigny", name: "Martigny" },
  { slug: "fribourg", cityId: "fribourg", name: "Fribourg" },
  { slug: "bulle", cityId: "bulle", name: "Bulle" },
  { slug: "murten", cityId: "murten", name: "Murten" },
  { slug: "neuchatel", cityId: "neuchatel", name: "Neuchâtel" },
  { slug: "la-chaux-de-fonds", cityId: "la-chaux-de-fonds", name: "La Chaux-de-Fonds" },
  { slug: "solothurn", cityId: "solothurn", name: "Solothurn" },
  { slug: "olten", cityId: "olten", name: "Olten" },
  { slug: "grenchen", cityId: "grenchen", name: "Grenchen" },
  { slug: "schwyz", cityId: "schwyz", name: "Schwyz" },
  { slug: "einsiedeln", cityId: "einsiedeln", name: "Einsiedeln" },
  { slug: "pfaffikon-sz", cityId: "pfaffikon-sz", name: "Pfäffikon SZ" },
  { slug: "kussnacht", cityId: "kussnacht", name: "Küssnacht am Rigi" },
  { slug: "stans", cityId: "stans", name: "Stans" },
  { slug: "sarnen", cityId: "sarnen", name: "Sarnen" },
  { slug: "engelberg", cityId: "engelberg", name: "Engelberg" },
  { slug: "altdorf", cityId: "altdorf", name: "Altdorf" },
  { slug: "andermatt", cityId: "andermatt", name: "Andermatt" },
  { slug: "glarus", cityId: "glarus", name: "Glarus" },
  { slug: "herisau", cityId: "herisau", name: "Herisau" },
  { slug: "appenzell", cityId: "appenzell", name: "Appenzell" },
  { slug: "delemont", cityId: "delemont", name: "Delémont" },
  { slug: "vaduz", cityId: "vaduz", name: "Vaduz (FL)" },
  { slug: "de-munich", cityId: "de-munich", name: "München" },
  { slug: "de-stuttgart", cityId: "de-stuttgart", name: "Stuttgart" },
  { slug: "de-frankfurt", cityId: "de-frankfurt", name: "Frankfurt am Main" },
  { slug: "de-freiburg", cityId: "de-freiburg", name: "Freiburg im Breisgau" },
  { slug: "de-konstanz", cityId: "de-konstanz", name: "Konstanz" },
  { slug: "de-friedrichshafen", cityId: "de-friedrichshafen", name: "Friedrichshafen" },
  { slug: "de-loerrach", cityId: "de-loerrach", name: "Lörrach" },
  { slug: "de-karlsruhe", cityId: "de-karlsruhe", name: "Karlsruhe" },
  { slug: "de-mannheim", cityId: "de-mannheim", name: "Mannheim" },
  { slug: "de-nuremberg", cityId: "de-nuremberg", name: "Nürnberg" },
  { slug: "de-cologne", cityId: "de-cologne", name: "Köln" },
  { slug: "de-ulm", cityId: "de-ulm", name: "Ulm" },
  { slug: "fr-strasbourg", cityId: "fr-strasbourg", name: "Strasbourg" },
  { slug: "fr-mulhouse", cityId: "fr-mulhouse", name: "Mulhouse" },
  { slug: "fr-colmar", cityId: "fr-colmar", name: "Colmar" },
  { slug: "fr-lyon", cityId: "fr-lyon", name: "Lyon" },
  { slug: "fr-annecy", cityId: "fr-annecy", name: "Annecy" },
  { slug: "fr-chamonix", cityId: "fr-chamonix", name: "Chamonix-Mont-Blanc" },
  { slug: "fr-grenoble", cityId: "fr-grenoble", name: "Grenoble" },
  { slug: "fr-dijon", cityId: "fr-dijon", name: "Dijon" },
  { slug: "fr-besancon", cityId: "fr-besancon", name: "Besançon" },
  { slug: "fr-paris", cityId: "fr-paris", name: "Paris" },
  { slug: "fr-nice", cityId: "fr-nice", name: "Nice" },
  { slug: "fr-marseille", cityId: "fr-marseille", name: "Marseille" },
  { slug: "it-milan", cityId: "it-milan", name: "Milano" },
  { slug: "it-como", cityId: "it-como", name: "Como" },
  { slug: "it-varese", cityId: "it-varese", name: "Varese" },
  { slug: "it-turin", cityId: "it-turin", name: "Torino" },
  { slug: "it-bergamo", cityId: "it-bergamo", name: "Bergamo" },
  { slug: "it-domodossola", cityId: "it-domodossola", name: "Domodossola" },
  { slug: "it-verona", cityId: "it-verona", name: "Verona" },
  { slug: "it-venice", cityId: "it-venice", name: "Venezia" },
  { slug: "it-genoa", cityId: "it-genoa", name: "Genova" },
  { slug: "it-bologna", cityId: "it-bologna", name: "Bologna" },
  { slug: "it-florence", cityId: "it-florence", name: "Firenze" },
  { slug: "at-innsbruck", cityId: "at-innsbruck", name: "Innsbruck" },
  { slug: "at-bregenz", cityId: "at-bregenz", name: "Bregenz" },
  { slug: "at-feldkirch", cityId: "at-feldkirch", name: "Feldkirch" },
  { slug: "at-st-anton", cityId: "at-st-anton", name: "St. Anton am Arlberg" },
  { slug: "at-ischgl", cityId: "at-ischgl", name: "Ischgl" },
  { slug: "at-lech", cityId: "at-lech", name: "Lech am Arlberg" },
  { slug: "at-salzburg", cityId: "at-salzburg", name: "Salzburg" },
  { slug: "at-vienna", cityId: "at-vienna", name: "Wien" },
  { slug: "at-graz", cityId: "at-graz", name: "Graz" },
  { slug: "at-linz", cityId: "at-linz", name: "Linz" },
  { slug: "li-schaan", cityId: "li-schaan", name: "Schaan" },
];
